import request from '@/utils/request';

// 获取抽奖活动列表
export function queryLotteryActivityConfigPageList(data) {
  return request({
    url: '/lottery/activity/config/queryLotteryActivityConfigPageList',
    method: 'POST',
    data
  });
}
// 删除抽奖配置-抽奖活动
export function removeLotteryActivityConfigById(data) {
  return request({
    url: '/lottery/activity/config/removeLotteryActivityConfigById',
    method: 'POST',
    data
  });
}
// 新增抽奖活动
export function saveLotteryActivityConfig(data) {
  return request({
    url: '/lottery/activity/config/saveLotteryActivityConfig',
    method: 'POST',
    data
  });
}
// 修改抽奖活动
export function updateLotteryActivityConfig(data) {
  return request({
    url: '/lottery/activity/config/updateLotteryActivityConfig',
    method: 'POST',
    data
  });
}
// 根据业务主键获取抽奖配置-抽奖活动明细
export function fetchLotteryActivityConfigDetailById(data) {
  return request({
    url: '/lottery/activity/config/fetchLotteryActivityConfigDetailById',
    method: 'POST',
    data
  });
}
// 生成小程序码
export function generateWechatUnlimitedQrCode(data) {
  return request({
    url: '/lottery/activity/config/generateWechatUnlimitedQrCode',
    method: 'POST',
    data
  });
}
// 奖品管理-奖品列表
export function queryLotteryActivityPrizePageList(data) {
  return request({
    url: '/lottery/activity/prize/queryLotteryActivityPrizePageList',
    method: 'POST',
    data
  });
}
// 奖品管理-删除
export function removeLotteryActivityPrizeById(data) {
  return request({
    url: '/lottery/activity/prize/removeLotteryActivityPrizeById',
    method: 'POST',
    data
  });
}
// 奖品管理-新增
export function saveLotteryActivityPrize(data) {
  return request({
    url: '/lottery/activity/prize/saveLotteryActivityPrize',
    method: 'POST',
    data
  });
}
// 奖品管理-编辑
export function updateLotteryActivityPrize(data) {
  return request({
    url: '/lottery/activity/prize/updateLotteryActivityPrize',
    method: 'POST',
    data
  });
}
// 奖品管理-编辑明细
export function fetchLotteryActivityPrizeDetailById(data) {
  return request({
    url: '/lottery/activity/prize/fetchLotteryActivityPrizeDetailById',
    method: 'POST',
    data
  });
}
// 奖品管理-获取奖品商品数据
export function queryEnableGoodsSpecPageList(data) {
  return request({
    url: '/lottery/activity/prize/queryEnableGoodsSpecPageList',
    method: 'POST',
    data
  });
}
// 奖品管理-获取奖品优惠券数据
export function queryEnableCouponPageList(data) {
  return request({
    url: '/lottery/activity/prize/queryEnableCouponPageList',
    method: 'POST',
    data
  });
}
// 中奖记录列表-获取抽奖配置-中奖记录列表
export function queryLotteryActivityLogPageList(data) {
  return request({
    url: '/lottery/activity/log/queryLotteryActivityLogPageList',
    method: 'POST',
    data
  });
}
// 中奖记录列表-获取所有的抽奖活动
export function queryAllLotteryActivityList(data) {
  return request({
    url: '/lottery/activity/config/queryAllLotteryActivityList',
    method: 'POST',
    data
  });
}
// 已输入抽奖概率
export function getLotteryPrizeTotalWinProbability(data) {
  return request({
    url: '/lottery/activity/prize/getLotteryPrizeTotalWinProbability',
    method: 'POST',
    data
  });
}


// WEBPACK FOOTER //
// ./src/api/prizeDraw.js